var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 180.95538057742783 100.0",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l180.95538 0l0 100.0l-180.95538 0l0 -100.0z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l180.95538 0l0 100.0l-180.95538 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m4.528956 63.997147l0 0c0 -17.778416 14.41025 -32.190674 32.186188 -32.190674l0 0c8.536312 0 16.722996 3.391508 22.759075 9.428431c6.0360794 6.0369225 9.427116 14.224743 9.427116 22.762241l0 0c0 17.77842 -14.410248 32.190674 -32.18619 32.190674l0 0c-17.77594 0 -32.186188 -14.412254 -32.186188 -32.190674z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m4.528956 63.997147l0 0c0 -17.778416 14.41025 -32.190674 32.186188 -32.190674l0 0c8.536312 0 16.722996 3.391508 22.759075 9.428431c6.0360794 6.0369225 9.427116 14.224743 9.427116 22.762241l0 0c0 17.77842 -14.410248 32.190674 -32.18619 32.190674l0 0c-17.77594 0 -32.186188 -14.412254 -32.186188 -32.190674z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m112.05442 63.997147l0 0c0 -17.778416 14.410248 -32.190674 32.186195 -32.190674l0 0c8.536301 0 16.722992 3.391508 22.759079 9.428431c6.036072 6.0369225 9.427109 14.224743 9.427109 22.762241l0 0c0 17.77842 -14.410248 32.190674 -32.186188 32.190674l0 0c-17.775948 0 -32.186195 -14.412254 -32.186195 -32.190674z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m112.05442 63.997147l0 0c0 -17.778416 14.410248 -32.190674 32.186195 -32.190674l0 0c8.536301 0 16.722992 3.391508 22.759079 9.428431c6.036072 6.0369225 9.427109 14.224743 9.427109 22.762241l0 0c0 17.77842 -14.410248 32.190674 -32.186188 32.190674l0 0c-17.775948 0 -32.186195 -14.412254 -32.186195 -32.190674z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m143.62819 62.380806l-17.624146 -57.031254",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m143.62819 62.380806l-17.624146 -57.031254",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m78.2336 62.721786l-17.952759 -57.354332",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m78.2336 62.721786l-17.952759 -57.354332",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m77.429886 62.085896l52.600266 -44.372765",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m77.429886 62.085896l52.600266 -44.372765",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m129.75229 16.811384l-63.147537 10.276514",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m129.75229 16.811384l-63.147537 10.276514",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m35.51181 64.08137l31.370079 -36.40945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m35.51181 64.08137l31.370079 -36.40945",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m35.104702 63.55478l44.094486 -2.2047234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cc0000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m35.104702 63.55478l44.094486 -2.2047234",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m128.4831 5.2615347l-12.503937 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m128.4831 5.2615347l-12.503937 0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m49.25891 4.8153963l0 0c0 -0.55443096 0.44945526 -1.003886 1.0038872 -1.003886l15.60194 0c0.2662506 0 0.5215912 0.1057663 0.7098541 0.29403138c0.18826294 0.18826532 0.29402924 0.4436078 0.29402924 0.7098546l0 4.0154247c0 0.55443096 -0.44945526 1.0038862 -1.0038834 1.0038862l-15.60194 0c-0.5544319 0 -1.0038872 -0.44945526 -1.0038872 -1.0038862z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 4,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m49.25891 4.8153963l0 0c0 -0.55443096 0.44945526 -1.003886 1.0038872 -1.003886l15.60194 0c0.2662506 0 0.5215912 0.1057663 0.7098541 0.29403138c0.18826294 0.18826532 0.29402924 0.4436078 0.29402924 0.7098546l0 4.0154247c0 0.55443096 -0.44945526 1.0038862 -1.0038834 1.0038862l-15.60194 0c-0.5544319 0 -1.0038872 -0.44945526 -1.0038872 -1.0038862z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBike);
export default __webpack_public_path__ + "static/media/bike.25ada020c4faa64f1f11ce829a89d467.svg";
export { ForwardRef as ReactComponent };